import { render, staticRenderFns } from "./masterDataValue.vue?vue&type=template&id=2fe4d7d3&scoped=true"
import script from "./masterDataValue.vue?vue&type=script&lang=js"
export * from "./masterDataValue.vue?vue&type=script&lang=js"
import style0 from "./masterDataValue.vue?vue&type=style&index=0&id=2fe4d7d3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe4d7d3",
  null
  
)

export default component.exports